import { Injectable, Signal } from '@angular/core';

import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import {
    CheckPersonRulesMatrixModel,
    CourtForAddBookingModel,
    CourtForAddBookingOptionsModel,
    CourtForAddBookingTimeSlotsModel,
    PersonModel
} from '@bayclubs/court-booking-employee-api';
import { BcStateListContext } from '@bayclubs/state';

import { utils } from '@bayclubs/ui-core';
import { CourtBookingSaveTimeSlotModel } from '../models/court-booking-save-form.model';
import * as actions from './court-booking-save.actions';
import { CourtBookingSaveSelectors } from './court-booking-save.selectors';

@Injectable({ providedIn: 'root' })
export class CourtBookingSaveFacade {
    players$: Observable<BcStateListContext<PersonModel>> = this.store.select(CourtBookingSaveSelectors.getPlayers);
    courts$: Observable<BcStateListContext<CourtForAddBookingModel>> = this.store.select(CourtBookingSaveSelectors.getCourts);
    courtOptions$: Observable<CourtForAddBookingOptionsModel[]> = this.store.select(CourtBookingSaveSelectors.getCourtOptions);
    timeSlots$: Observable<CourtForAddBookingTimeSlotsModel[]> = this.store.select(CourtBookingSaveSelectors.getTimeSlots);
    isCourtSelected$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.isCourtSelected);
    isCategoryOptionSelected$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.isCategoryOptionSelected);
    isTimePeriodSelected$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.isTimePeriodSelected);
    availableTimeSlots$: Observable<BcStateListContext<CourtBookingSaveTimeSlotModel>> = this.store.select(CourtBookingSaveSelectors.getAvailableTimeSlots);
    selectedTimeSlots$: Observable<CourtBookingSaveTimeSlotModel> = this.store.select(CourtBookingSaveSelectors.getSelectedTimeSlot);
    isSelectedTimeSlotUnavailable$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.isSelectedTimeSlotUnavailable);
    selectedTimeSlotsUnavailabilityMessage$: Observable<string> = this.store.select(CourtBookingSaveSelectors.selectedTimeSlotUnavailabilityMessage);

    showTwoPlayers$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.showTwoPlayers);
    showFourPlayers$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.showFourPlayers);

    secondPlayerRulesMatrix$: Observable<CheckPersonRulesMatrixModel> = this.store.select(CourtBookingSaveSelectors.secondPlayerRulesMatrix);
    thirdPlayerRulesMatrix$: Observable<CheckPersonRulesMatrixModel> = this.store.select(CourtBookingSaveSelectors.thirdPlayerRulesMatrix);
    fourthPlayerRulesMatrix$: Observable<CheckPersonRulesMatrixModel> = this.store.select(CourtBookingSaveSelectors.fourthPlayerRulesMatrix);
    selectedCategoryName$: Observable<string> = this.store.select(CourtBookingSaveSelectors.selectedCategoryName);
    firstPlayerCanBook$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.firstPlayerCanBook);

    typeSelectEnabled$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.typeSelectEnabled);
    timePeriodEnabled$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.timePeriodEnabled);
    timeEnabled$: Observable<boolean> = this.store.select(CourtBookingSaveSelectors.timeEnabled);

    isMainPlayerSelected: Signal<boolean> = this.store.selectSignal(CourtBookingSaveSelectors.isMainPlayerSelected);
    firstPlayerRulesMatrix: Signal<CheckPersonRulesMatrixModel | null> = this.store.selectSignal(CourtBookingSaveSelectors.firstPlayerRulesMatrix);
    showFormSpinner: Signal<boolean> = this.store.selectSignal(CourtBookingSaveSelectors.showFormSpinner);
    isFormValid: Signal<boolean> = this.store.selectSignal(CourtBookingSaveSelectors.isFormValid);
    formLoading: Signal<boolean> = this.store.selectSignal(CourtBookingSaveSelectors.formLoading);

    constructor(private store: Store) { }

    loadCourts = (date: utils.BcDate) => this.store.dispatch(new actions.LoadCourtsAction(date));
    searchPlayers = (search: string) => this.store.dispatch(new actions.SearchPlayersAction(search));
    clearSaveForm = () => this.store.dispatch(new actions.ClearSaveFormAction());
    loadAvailableTimeSlots = (timeSlotId: string, date: utils.BcDate, timeFromInMinutes: number) =>
        this.store.dispatch(new actions.LoadAvailableTimeSlotsAction(timeSlotId, date, timeFromInMinutes));
    clearPlayers = () => this.store.dispatch(new actions.ClearPlayersAction());
    saveCourtBooking = () => this.store.dispatch(new actions.SaveCourtBookingAction());
    checkPlayersMatrix = () => this.store.dispatch(new actions.CheckPlayersMatrixAction());
}
